import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const AnimatedCircleCounter = ({ targetNumber, className = "" }) => {
  const [currentNumber, setCurrentNumber] = useState(0);

  useEffect(() => {
    let animationFrame;
    const duration = 3000;
    const startTime = performance.now();

    const updateNumber = (time) => {
      const progress = Math.min((time - startTime) / duration, 1);
      setCurrentNumber(Math.floor(progress * targetNumber));

      if (progress < 1) {
        animationFrame = requestAnimationFrame(updateNumber);
      }
    };

    animationFrame = requestAnimationFrame(updateNumber);

    return () => cancelAnimationFrame(animationFrame);
  }, [targetNumber]);

  return (
    <div className={className}>
      {/* Animated Circle */}
      <motion.div
        initial={{ scale: 0 }}
        animate={{
          scale: [0.65, 0.85, 0.65],
          rotate: 360,
          boxShadow: [
            "0px 0px 0px rgba(0, 255, 0, 0.5)",
            "0px 0px 20px rgba(0, 255, 0, 0.8)",
            "0px 0px 0px rgba(0, 255, 0, 0.5)",
          ],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          repeatType: "loop",
        }}
        className="relative flex items-center justify-center w-40 h-40 rounded-full border-8 border-green-700"
      >
        {/* Number Counter */}
        <motion.span
          className="text-green-600 text-4xl font-bold"
          key={currentNumber}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3 }}
        >
          {currentNumber}
        </motion.span>

        {/* Rotating inner circle */}
        <motion.div
          className="absolute w-32 h-32 rounded-full border-4 border-green-600"
          initial={{ rotate: 0 }}
          animate={{ rotate: 360 }}
          transition={{
            duration: 5,
            ease: "linear",
            repeat: Infinity,
          }}
        />
      </motion.div>
    </div>
  );
};

export default AnimatedCircleCounter;
